import './index.less';
import { FilePDFIcon } from 'components/Icons';
import { UnderlineText } from 'components/RevxTypography';
import React from 'react';

type Props = {
  title: string;
  link: string;
  hideIcon?: boolean;
  callback?: () => void;
};
export const PDFLink = ({ title, link, hideIcon, callback }: Props) => {
  const clickHandler = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    callback?.();
    window.open(link, '_blank');
  };
  return (
    <span className="pdf-link">
      {!hideIcon && <FilePDFIcon />}
      <UnderlineText color="blue" size="small">
        <a target="_blank" rel="noreferrer" onClick={clickHandler}>
          {title}
        </a>
      </UnderlineText>
    </span>
  );
};
